module.exports = __webpack_public_path__ + "img/trapleuning.bfbcf16b.jpg";